import { render, staticRenderFns } from "./indexsixth.vue?vue&type=template&id=41d4d3fc&scoped=true"
import script from "./indexsixth.vue?vue&type=script&lang=js"
export * from "./indexsixth.vue?vue&type=script&lang=js"
import style0 from "./indexsixth.vue?vue&type=style&index=0&id=41d4d3fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d4d3fc",
  null
  
)

export default component.exports